export default __webpack_public_path__ + "static/media/placeholder_portfolio02-en-web.770c0297.png";